import * as z from 'zod/mini'
import { isoDateTime } from '../../schemas/common'
import { selectUsersQuery } from '../select-users.dto'

/** The selected users' events in a window. Both bounds are instants (`toISOString`). */
export const getUsersCalendarEventsQuery = z.extend(selectUsersQuery, {
  start: z.optional(isoDateTime),
  end: z.optional(isoDateTime),
})
export type GetUsersCalendarEventsQuery = z.infer<typeof getUsersCalendarEventsQuery>
